import { render, staticRenderFns } from "./bottomView.vue?vue&type=template&id=4bdd2d02&scoped=true"
import script from "./bottomView.vue?vue&type=script&lang=js"
export * from "./bottomView.vue?vue&type=script&lang=js"
import style0 from "./bottomView.vue?vue&type=style&index=0&id=4bdd2d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd2d02",
  null
  
)

export default component.exports